<template lang="pug">
VListSubheader
  strong {{ translatedRoleName }}
VList(tag="ul")
  VListItem(
    v-for="(name, i) in personNames"
    :key="i"
    tag="li"
  )
    template(#prepend)
      VAvatar(
        size="24"
        color="secondary"
      )
        VIcon {{ mdiAccount }}
    VListItemTitle {{ name }}
</template>

<script setup lang="ts">
import { mdiAccount } from "@mdi/js";

const i18n = useI18n();

interface Props {
  roleName: string;
  personNames: string[];
}

const props = defineProps<Props>();

const translatedRoleName = computed<string>(() =>
  i18n.t(`TheComment.${props.roleName}`),
);
</script>
